import { Box, Link } from "@mui/material";
import * as React from "react";

type Props = {
    text: string;
    onClick: () => void;
}

export const MprcBreadcrumbLink: React.FC<Props> = (props) => {
    const { text, onClick } = props;
    return (
        <Box sx={{
            maxWidth: "350px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textWrap: "nowrap"
        }}>
            <Link
                underline="hover"
                color="inherit"
                fontSize="12px"
                href="#"
                onClick={onClick}
            >
                {text}
            </Link>
        </Box>
    );
};
